import React from 'react';

function PatientDetailSegmentNav({ tabs, activeTab, onTabChange }) {
    return (
        <div className="web-booking-segment" role="tablist" aria-label="Patient detail sections">
            {tabs.map((tab) => (
                <button
                    key={tab.id}
                    type="button"
                    role="tab"
                    aria-selected={activeTab === tab.id}
                    className={`web-booking-segment__item ${activeTab === tab.id ? 'is-active' : ''}`}
                    onClick={() => onTabChange(tab.id)}
                >
                    <i className={`bi ${tab.icon} me-1`} />
                    {tab.label}
                </button>
            ))}
        </div>
    );
}

export default PatientDetailSegmentNav;
